<template>
  <div>
    <return-goods />

  </div>
</template>

<script>
// 获取接口地址
import ReturnGoods from '../components/thrg/returnGoods.vue'

export default {
  name: 'Thrk',
  components: {
    // sideMenu,
    // Header,
    ReturnGoods
  },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style scoped>
</style>
